import CalendarEventForm from './components/CalendarEventForm/CalendarEventForm.vue'
import { emitter } from '@kwixeo/interface-vue'
import { AxiosResponse } from 'axios'
import Vue from 'vue'

const modals: KwixeoInterface.DynamicModals = [{
  key: 'event-form',
  title: event => event && event.id ? 'calendars.event.editTitle' : 'calendars.event.addTitle',
  component: CalendarEventForm,
  size: 'md',
  scrollable: false,
  attributes: {
    askDelete: false
  },
  events: {
    cancelDelete: (modal: KwixeoInterface.DynamicModal): void => {
      if (modal.attributes) {
        modal.attributes.askDelete = false
      }
    },
    deleted: (modal: KwixeoInterface.DynamicModal, args: KwixeoInterface.AnyValue, close: () => void): void => {
      close()
      emitter.emit('eventDeleted', modal.originalValue as KwixeoCalendars.Event)
    }
  },
  submitted: (response: AxiosResponse, modal: KwixeoInterface.DynamicModal): void => {
    const event = response.data
    if (!modal.originalValue || !modal.originalValue.id) {
      emitter.emit('eventCreated', event)
    } else {
      emitter.emit('eventUpdated', {
        old: modal.originalValue as KwixeoCalendars.Event,
        new: event
      })
    }
  },
  buttons: [
    {
      label: 'Supprimer',
      variant: 'primary',
      show: (modal: KwixeoInterface.DynamicModal): boolean => modal.originalValue && modal.originalValue.id,
      click: (modal: KwixeoInterface.DynamicModal): void => {
        if (modal.attributes) {
          modal.attributes.askDelete = true
        }
      }
    },
    {
      label: 'Créer une tâche',
      variant: 'primary',
      show: (modal: KwixeoInterface.DynamicModal): boolean => !modal.originalValue || !modal.originalValue.id,
      click: (modal: KwixeoInterface.DynamicModal, { cancel }: KwixeoInterface.DynamicModalButtonEvents): void => {
        cancel()

        Vue.prototype.$kwCalendars.store.dispatch('dynamicModals/openModal', {
          key: 'task-form',
          value: {
            datetime: modal.originalValue?.begin,
            elements: modal.originalValue?.elements
          }
        })
      }
    },
    {
      separator: true
    },
    {
      label: 'Annuler',
      click: (modal: KwixeoInterface.DynamicModal, { cancel }: KwixeoInterface.DynamicModalButtonEvents): void => {
        cancel()
      }
    },
    {
      label: 'Enregistrer',
      variant: 'primary',
      click: (modal: KwixeoInterface.DynamicModal, { ok }: KwixeoInterface.DynamicModalButtonEvents): void => {
        ok()
      }
    }
  ]
}]

export default modals
